import React from 'react';
import { ITableDataSource } from 'models/table';
import { colors } from 'theme/colors';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import { useTranslations } from 'hooks/useTranslations';
import { emptyFieldHolder } from 'components/molecules/CardList';
import { EMarkingTypes } from 'constants/Markings';
import { EAdditionalFields, EMarkingsLabels } from './helpers';
import { ETransactionTypes } from 'constants/TransactionTypes';
import { DetailsMarkingsItem } from './DetailsMarkingsItem';

interface ITransactionDetailsMarkingsCard {
  data: ITableDataSource;
  fieldsForTransactionType: (EMarkingTypes | EAdditionalFields)[];
  transactionType?: ETransactionTypes;
}

const TransactionDetailsMarkingsCard = ({
  data,
  fieldsForTransactionType,
  transactionType,
}: ITransactionDetailsMarkingsCard) => {
  const { t } = useTranslations();

  return (
    <Grid
      container
      sx={{
        border: colors.gray200,
        borderRadius: '4px',
        overflow: 'hidden',
        mt: 1,
        backgroundColor: colors.gray100,
      }}
    >
      <Grid sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t(EMarkingsLabels.fireCycleID)}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(data.id)}</Typography>
      </Grid>
      <DetailsMarkingsItem
        data={data}
        transactionType={transactionType}
        fieldsForTransactionType={fieldsForTransactionType}
      />
    </Grid>
  );
};

export { TransactionDetailsMarkingsCard };
